import { render } from "./PerformanceEvaluation.vue?vue&type=template&id=5923120b&scoped=true&lang=html"
import script from "./PerformanceEvaluation.vue?vue&type=script&lang=js"
export * from "./PerformanceEvaluation.vue?vue&type=script&lang=js"

import "./PerformanceEvaluation.vue?vue&type=style&index=0&id=5923120b&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-5923120b"

export default script